import { createSlice } from "@reduxjs/toolkit";

interface ChatBot {
  loader: boolean;
  showWidget: boolean;
  loadZendeskAfterLoad: boolean;
  openAmberCopilot: boolean;
  isChatbotOpen: boolean;
}

const initialState: ChatBot = {
  loader: false,
  showWidget: false,
  loadZendeskAfterLoad: false,
  openAmberCopilot: false,
  isChatbotOpen: false,
};

const chatBotReducer = createSlice({
  name: "chatBotReducer",
  initialState,
  reducers: {
    toggleLoaderState: (state, { payload }) => {
      state.loader = payload;
    },

    toggleShowWidgetState: (state, { payload }) => {
      state.showWidget = payload;
    },

    toggleLoadZendeskAfterLogin: (state, { payload }) => {
      state.loadZendeskAfterLoad = payload;
    },

    setOpenAmberCopilot: (state, { payload }) => {
      state.openAmberCopilot = payload;
    },

    setIsChatbotOpen: (state, { payload }) => {
      state.isChatbotOpen = payload;
    },
  },
});

export default chatBotReducer.reducer;
export const {
  toggleLoaderState,
  toggleShowWidgetState,
  toggleLoadZendeskAfterLogin,
  setOpenAmberCopilot,
  setIsChatbotOpen,
} = chatBotReducer.actions;
